export default "__VITE_ASSET__Cdpa6ngw__"